import React, { useEffect, useState } from 'react';
import './App.scss';
import Scene1 from './Scene1/Scene1'
import Menu from './Menu/Menu'
import { AppSceneContext } from './SceneState/SceneState'
import { isMobile, isTablet } from 'react-device-detect';
import MobileView from './MobileView/MobileView';
import useWindowDimensions from '../hooks/getWindowDimensions';

function App() {

  const windowDimensions = useWindowDimensions();
  const [scene, setScene] = useState<string>('chat')
  const [gotoScene, setGotoScene] = useState<string>('')
  const [act, setAct] = useState<string>('')
  const [aniHeight, setAniHeight] = useState<number>(0)

  useEffect(() => {
    if (isMobile || isTablet) {
      document.body.classList.add('mobile--view');
    } else {
      document.body.classList.remove('mobile--view');
    }

  }, [])


  return (
    <AppSceneContext.Provider value={{ scene, setScene, act, setAct, aniHeight, setAniHeight, gotoScene, setGotoScene }}>
      {!isMobile &&
        <div className="gws-demo--chrome" style={{ height: aniHeight }}>
          <div className={"gws-demo " + (windowDimensions.width < 1080 || windowDimensions.height < 720 ? "narrow" : (windowDimensions.height > 1200 ? "wide" : ""))}>
            <Menu />
            <Scene1 />
          </div>
        </div>
      }
      {isMobile &&
        <MobileView />
      }
    </AppSceneContext.Provider >
  );
}

export default App;
